import { makeRequest } from 'utils/requestLogger';

export default (id) => makeRequest('post', `/api/live_discussions/${id}/start`);



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/startLiveDiscussion.js